import type { HebeModel } from '@sbt-web/adv';

const advFallbackConfigDesktop: HebeModel = {
  name: 'userprofile',
  page_level_settings: {},
  slots: [
    {
      //Ex: dfp_box_homepage_desktop
      container_id: 'userprofile-belowtheratings',
      name: 'the slot below the ratings box',
      configurations: {
        gam: [
          {
            sequence: 0,
            unit_id: '/11825272/login/subito-desktop-login-userpage',
            sizes: ['120x600', '160x600'],
          },
        ],
      },
    },
  ],
};

export { advFallbackConfigDesktop };
